(() => {
  const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
  let observer;
  const setup = (root = document) => {
    root.querySelectorAll('.maison-home h1, .maison-home h2, .m-house-door h3, .m-tailored-intro h1, .m-private h1, .m-private h2, .m-footer__contact, .m-footer__signature').forEach(item => {
      item.classList.add('m-silver');
      item.setAttribute('data-m-silver', '');
    });
    const items = root.querySelectorAll('[data-m-reveal]');
    if (!motion.matches && 'IntersectionObserver' in window) {
      document.documentElement.classList.add('m-motion');
      observer ||= new IntersectionObserver(entries => entries.forEach(entry => {
        if (entry.isIntersecting) { entry.target.classList.add('is-visible'); observer.unobserve(entry.target); }
      }), { threshold: .08, rootMargin: '0px 0px 30px 0px' });
      items.forEach(item => observer.observe(item));
    } else items.forEach(item => item.classList.add('is-visible'));
  };
  setup();
  document.addEventListener('shopify:section:load', event => setup(event.target));
  let ticking = false;
  const update = () => {
    ticking = false;
    if (motion.matches) return;
    document.querySelectorAll('[data-m-silver]').forEach(item => {
      const rect = item.getBoundingClientRect();
      if (rect.bottom < 0 || rect.top > innerHeight) return;
      const progress = Math.max(0, Math.min(1, (innerHeight - rect.top) / (innerHeight + rect.height)));
      item.style.setProperty('--m-light-pos', `${15 + progress * 75}%`);
    });
    document.querySelectorAll('[data-m-scene]').forEach(scene => {
      const rect = scene.getBoundingClientRect();
      if (rect.bottom < 0 || rect.top > innerHeight) return;
      const media = scene.querySelector('[data-m-parallax]');
      if (media) media.style.transform = `translate3d(0,${Math.max(-40, Math.min(40, -rect.top * .075))}px,0)`;
    });
  };
  window.addEventListener('scroll', () => { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
  update();
  motion.addEventListener('change', () => {
    document.documentElement.classList.toggle('m-motion', !motion.matches);
    if (motion.matches) document.querySelectorAll('[data-m-parallax]').forEach(x => x.style.transform = 'none');
    else setup();
  });
})();
